import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export const store = new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    usRecordSettings: {
      reloadFlag: 'N',
      chkIndex: 'ALL',
      symbol: '',
      syName: '',
      symChgFlag: 'N',
      chkDate: 'D',
      chkIndexChg: true
    },
    isLoading: false
  },
  getters: {
    getUsRecordSettings: (state) => {
      return state.usRecordSettings
    },
    getUsSymbolSetting: (state) => {
      return state.usRecordSettings.symbol
    },
    getUsSyNameSetting: (state) => {
      return state.usRecordSettings.syName
    },
    getUsChkIndexSetting: (state) => {
      return state.usRecordSettings.chkIndex
    },
    getUsSymChgFlagSetting: (state) => {
      return state.usRecordSettings.symChgFlag
    },
    getLodingBarSetting: (state) => {
      return state.isLoading
    },
    getUsChkDateSetting: (state) => {
      return state.usRecordSettings.chkDate
    },
    getUsChkIndexChgSetting: (state) => {
      return state.usRecordSettings.chkIndexChg
    }
  },
  mutations: {
    initUSdata: (state) => {
      state.usRecordSettings.syName = ''
      state.usRecordSettings.symbol = ''
      state.usRecordSettings.chkIndex = 'ALL'
      state.usRecordSettings.chkDate = 'D'
      state.usRecordSettings.chkIndexChg = false
    },
    saveUsSettings: (state, payLoad) => {
      state.usRecordSettings = payLoad
    },
    saveUsChkIndexChgSettings: (state, payLoad) => {
      state.usRecordSettings.chkIndexChg = payLoad
    },
    saveUsSymbolSetting: (state, payLoad) => {
      state.usRecordSettings.symbol = payLoad
    },
    saveUsSyNameSetting: (state, payLoad) => {
      state.usRecordSettings.syName = payLoad
    },
    saveUsChkIndexSetting: (state, payLoad) => {
      state.usRecordSettings.chkIndex = payLoad
    },
    saveUsSymChgFlagSetting: (state, payLoad) => {
      state.usRecordSettings.symChgFlag = payLoad
    },
    setLodingBarSetting: (state, payLoad) => {
      state.isLoading = payLoad
    },
    saveUsChkDateSetting: (state, payLoad) => {
      state.usRecordSettings.chkDate = payLoad
    }
  },
  actions: {
    initUSdata: ({ commit }, payLoad) => {
      commit('initUSdata', payLoad)
    },
    saveUsSettings: ({ commit }, payLoad) => {
      commit('saveUsSettings', payLoad)
    },
    saveUsChkIndexChgSettings: ({ commit }, payLoad) => {
      commit('saveUsChkIndexChgSettings', payLoad)
    },
    saveUsSymbolSetting: ({ commit }, payLoad) => {
      commit('saveUsSymbolSetting', payLoad)
    },
    saveUsSyNameSetting: ({ commit }, payLoad) => {
      commit('saveUsSyNameSetting', payLoad)
    },
    saveUsChkIndexSetting: ({ commit }, payLoad) => {
      commit('saveUsChkIndexSetting', payLoad)
    },
    saveUsSymChgFlagSetting: ({ commit }, payLoad) => {
      commit('saveUsSymChgFlagSetting', payLoad)
    },
    setLodingBarSetting: ({ commit }, payLoad) => {
      commit('setLodingBarSetting', payLoad)
    },
    saveUsChkDateSetting: ({ commit }, payLoad) => {
      commit('saveUsChkDateSetting', payLoad)
    }
  }
})

const init = () => {
  if (localStorage.chkIndex) {
    store.state.usRecordSettings.chkIndex = localStorage.chkIndex
  }

  if (localStorage.symbol) {
    store.state.usRecordSettings.symbol = localStorage.symbol
  }

  if (localStorage.syName) {
    store.state.usRecordSettings.syName = localStorage.syName
  }

  if (localStorage.reloadFlag) {
    store.state.usRecordSettings.reloadFlag = localStorage.reloadFlag
  }
}

init()



// WEBPACK FOOTER //
// ./src/store/store.js